import styled from 'styled-components'
import Modal from '~/components/molecules/Modal'
import Button from '~/components/atoms/Button'
import AccountDrawer from '~/components/molecules/AccountDrawer'

interface Props {
  show: boolean
  onClose(): void
}

export default function ManageIsAdultModal({ show, onClose }: Props) {
  return (
    <Modal show={show} type='slide' onClose={onClose}>
      <Container>
        <Title>18歳未満のユーザーは購入できません</Title>
        <Notice>
          あなたが18歳以上の場合、NSFWコンテンツを表示することで18歳以上のユーザーとして扱われます。
        </Notice>
        <Buttons>
          <AccountDrawer>
            <Button label='設定を変更' color='secondary' onClick={() => {}} />
          </AccountDrawer>
          <Button label='18歳になるまで待つ' color='cancel' onClick={onClose} />
        </Buttons>
      </Container>
    </Modal>
  )
}

const Container = styled.div`
  margin: 0 auto;
  text-align: center;
`

const Title = styled.p`
  ${({ theme }) => theme.fonts.Bold20};
  color: ${({ theme }) => theme.colors.OnSurface2};
  margin: 0 0 24px;
`

const Notice = styled.div`
  ${({ theme }) => theme.fonts.Bold16};
  color: ${({ theme }) => theme.colors.OnSurface5};
  margin: 0 0 24px;
`

const Buttons = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-template-rows: auto auto;
`
